
import { FiActivity, FiCpu } from "react-icons/fi";
import {
    FaBolt,
    FaBrain,
    FaBullseye,
    FaCloudSun,
    FaHeart,
    FaMoon,
    FaNotesMedical,
    FaPuzzlePiece,
    FaShieldHeart,
    FaSliders,
    FaGamepad, FaArrowsRotate,
    FaCapsules,
    FaChartLine,
    FaPeopleGroup,
    FaLayerGroup,
    FaWallet,
    FaMoneyBillTransfer,
    FaCircleCheck,
} from "react-icons/fa6";

export const section1Data = [
    {
        icon: FiCpu,
        title: "Brain Zen Pro",
        subtitle: "Advanced Memory & Cognitive Support",
        description:
            "Brain Zen Pro detects and treats depression, anxiety, ADHD, PTSD, and more. It combines neurofeedback with other therapies to improve cognitive performance. This low-cost program works in existing settings, is covered by most insurance, and helps facilities improve patient care and practice finances.",
        link: "/services/brain-zen-pro",
    },
    {
        icon: FiActivity,
        title: "Brain Brightening & Memory Care",
        subtitle: "Enhanced Cognitive Support for Seniors",
        description:
            "Our Brain Brightening Program improves memory care services in the geriatric population. Neurofeedback enhances memory, focus, and brain health, making it an ideal solution for seniors.",
        link: "/services/brain-memory-care",
    },
]

export const iconBenefitData = [
    {
        title: "Depression",
        description:
            "A mood disorder that causes persistent sadness and a lack of interest in life.",
        icon: FaCloudSun,
    },
    {
        title: "Anxiety",
        description:
            "Excessive worry and fear disrupt daily life, causing physical and emotional distress.",
        icon: FaHeart,
    },
    {
        title: "Attention & Focus Issues",
        description:
            "Issues with attention, focus, and impulse control often affect daily tasks.",
        icon: FaBullseye,
    },
    {
        title: "Sleep Problems & Disorders",
        description:
            "Poor sleep, from trouble falling or staying asleep, harms health.",
        icon: FaMoon,
    },
    {
        title: "Impulsive Behaviors",
        description:
            "Acting without thinking or challenging authority leads to conflicts.",
        icon: FaBolt,
    },
    {
        title: "Difficulty Regulating Emotions",
        description:
            "Struggling to control emotions can cause extreme reactions and mood swings.",
        icon: FaSliders,
    },
    {
        title: "Traumatic Brain Injury",
        description:
            "Rehabilitation and healing after a brain injury from an external cause.",
        icon: FaBrain,
    },
    {
        title: "Autism Spectrum Disorder",
        description: "Impacts social interactions, communication, and behavior.",
        icon: FaPeopleGroup,
    },
    {
        title: "Post-Traumatic Stress Disorder",
        description:
            "Triggered by trauma, it can cause anxiety, flashbacks, and emotional distress.",
        icon: FaShieldHeart,
    },
    {
        title: "Neurodevelopmental Disorders",
        description:
            "Disorders that affect brain development, learning, behavior, and functioning.",
        icon: FaPuzzlePiece,
    },
    {
        title: "Chronic Pain, Migraines & Neurological Issues",
        description:
            "Chronic pain such as headaches or migraines can be linked to neurological issues.",
        icon: FaNotesMedical,
    },
];

export const featureCardData = [
    {
        icon: <FaBrain />,
        title: "Brain Mapping (Neuro Mapping)",
        description:
            "Create a brain map with an EEG cap to measure brainwaves on your scalp. This 15-minute process shows a report of your brain's neuro mapping, helping us find areas for improvement.",
    },
    {
        icon: <FaGamepad />,
        title: "Interactive & Engaging Session",
        description:
            "We create a neurofeedback program from your brain map. It matches your unique brain patterns. You'll attend 1 or 2 30–45-minute sessions each week as needed. You'll wear an EEG cap and play games that use brainwaves to control them.",
    },
    {
        icon: <FaArrowsRotate />,
        title: "Transformative Sessions",
        description:
            "Some people experience changes in 5 to 10 sessions. However, for some patients it can take 30 to 40 sessions to change brain function. It helps the brain learn new behaviors, improving focus, emotions, and anxiety.",
    },
];

export const featureFlowData = [
    {
        icon: <FaCapsules />,
        title: "A No-Drug Solution",
        description: "A non-invasive approach without medication.",
        align: "bottom",
    },
    {
        icon: <FaBrain />,
        title: "Uplifted Emotion & Brain Efficiency",
        description: "Supports emotional balance and brain function.",
        align: "top",
    },
    {
        icon: <FaChartLine />,
        title: "Sustainable Outcomes",
        description: "Builds lasting improvements through brain training.",
        align: "bottom",
        featured: true,
    },
    {
        icon: <FaPeopleGroup />,
        title: "Applicability for All Age Groups",
        description: "Suitable for children, teens, and adults.",
        align: "top",
    },
];

export const section2Data = [
    {
        icon: FaShieldHeart,
        title: "Non-Invasive & Insurance-Friendly",
        description: "Affordable, covered by major insurers.",
    },
    {
        icon: FaLayerGroup,
        title: "Works With Other Treatments",
        description: "A perfect partner for any therapy.",
    },
    {
        icon: FaWallet,
        title: "Zero Upfront Expense",
        description: "No initial cost, just results.",
    },
    {
        icon: FaMoneyBillTransfer,
        title: "Simple Payments & Reimbursements",
        description: "Quick payments straight to your account.",
    },
    {
        icon: FaCircleCheck,
        title: "No-Risk Structure",
        description: "Pay only when you're reimbursed.",
    },
];